import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
  return Request('get', "api/stock-in-orders/index", data);
}

async function fetchOne(id,data) {
return Request('get', "api/stock-in-orders/view/" + id, data);
}
async function stockIn(data) {//入库
  return Request('post', "api/stock-in-orders/in", data)
}

async function add(data) {// 新增出库单
  //data = delSomeFields(data);// 去除过多杂项
  return Request('post', "api/stock-in-orders/add", data);
}

async function edit(id, data) {// 编辑入库单
  return Request('post', "api/stock-in-orders/edit/" + id, data);
}

async function cancel(id) {// 作废入库单
  return Request('post', "api/stock-in-orders/cancel/" + id);
}

async function imports(file) {
  // 期初导入
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/stock-in-orders/import-initialize", data);
}

async function materialImports(accountSettings, file) {
  // 采购入库导入
  store.dispatch('fullscreenLoading')
  var data = new FormData();
  data.append("excel", file);
  data.append("product_date_setting", accountSettings);

  const response = await Request(
    'post',
    'api/stock-in-orders/import-purchase',
    data
  )
  // if (response.data && response.data.status.isOK()) {
  //   snackbar.info(i18n.t('Import.success', i18n.t('Order.title')))
  // }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 批量导出报表
async function exports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-in-orders/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 导出报表
async function orderExport(id) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-in-orders/detail-export/'+id)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function getImportTemplate(data) {
    return await Request('post', 'api/stock-in-orders/get-import-template', data)
}

async function stockOrderInPrint(id) {
  return Request('get', "api/stock-in-orders/stock-order-print/" + id)
}

async function stockOrdersInPrint(data) {
  return Request('get', "api/stock-in-orders/stock-orders-print/", data)
}

async function initializeTemplateExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-in-orders/initialize-template-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 导出商品模板
async function commonTemplateExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-in-orders/common-template-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function importMaterials(file, productDateSetting) {      //普通模板导入
  var data = new FormData()
  data.append('excel', file)
  data.append('product_date_setting', productDateSetting)
  return Request('post', "api/stock-in-orders/import-materials", data)
}

async function update(data) {
  return Request('post', 'api/stock-in-orders/update', data)
}

export default {
  fetch,
  fetchOne,
  cancel,
  stockIn,
  add,
  imports,
  materialImports,
  exports,
  orderExport,
  edit,
  getImportTemplate,
  stockOrderInPrint,
  stockOrdersInPrint,
  initializeTemplateExport,
  commonTemplateExport,
  importMaterials,
  update,
}